import { computed, Signal } from '@angular/core';
import { ThemeService } from './theme';

// V3's /v3/{name}Dark.{ext} / {name}Light.{ext} asset pair.
export function themeAsset(themeService: ThemeService, name: string, ext = 'svg'): Signal<string> {
  return computed(() => `/v3/${name}${themeService.isDark() ? 'Dark' : 'Light'}.${ext}`);
}
